/* ============================================================
   LONGEVITA — Product Enhancements JS
   Archivo: assets/longevita-product.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Utilidades ─────────────────────────────────────────── */
 function formatPrice(cents) {
  return '$' + Math.round(cents / 100).toLocaleString('es-CL');
}

  function qs(selector, ctx) {
    return (ctx || document).querySelector(selector);
  }

  function qsa(selector, ctx) {
    return Array.from((ctx || document).querySelectorAll(selector));
  }

  /* ── 1. SELECTOR DE CANTIDAD CON DESCUENTO ──────────────── */
  function initQtySelector() {
    var selector = qs('.lv-qty-selector');
    if (!selector) return;

    var opts      = qsa('.lv-qty-opt', selector);
    var savingsEl = qs('#lv-savings-msg');
    var ctaBtn    = qs('[name="add"]');           // botón nativo de Shopify
    var qtyInput  = qs('[name="quantity"]');       // input nativo de Shopify
    var priceEl   = qs('.lv-sticky-bar__price');

    function updateCTALabel(price) {
      if (!ctaBtn) return;
      var span = ctaBtn.querySelector('.lv-cta-price');
      if (!span) return;
      span.textContent = ' — ' + formatPrice(price);
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var qty     = parseInt(opt.dataset.qty, 10);
        var price   = parseInt(opt.dataset.price, 10);
        var savings = parseInt(opt.dataset.savings, 10);
        var basePrice = parseInt(opts[0].dataset.price, 10);

        /* Actualizar estado visual */
        opts.forEach(function (o) {
          o.classList.remove('lv-qty-opt--active');
          o.setAttribute('aria-pressed', 'false');
        });
        opt.classList.add('lv-qty-opt--active');
        opt.setAttribute('aria-pressed', 'true');

        /* Actualizar input de cantidad nativo */
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* Actualizar mensaje de ahorro */
        if (savingsEl) {
          if (savings > 0) {
            var saved = (basePrice * qty) - price;
            savingsEl.textContent =
              'Ahorras ' + formatPrice(saved) + ' con este pack (–' + savings + '%)';
          } else {
            savingsEl.textContent = '';
          }
        }

        /* Actualizar precio en sticky bar */
        if (priceEl) priceEl.textContent = formatPrice(price);

        /* Actualizar etiqueta del botón de carrito */
        updateCTALabel(price);
      });
    });
  }

  /* ── 2. TABS ────────────────────────────────────────────── */
  function initTabs() {
    qsa('.lv-tabs').forEach(function (tabsEl) {
      var btns   = qsa('.lv-tabs__btn', tabsEl);
      var panels = qsa('.lv-tabs__panel', tabsEl);

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.tab;

          btns.forEach(function (b) {
            b.classList.remove('lv-tabs__btn--active');
            b.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('lv-tabs__panel--active');
          });

          btn.classList.add('lv-tabs__btn--active');
          btn.setAttribute('aria-selected', 'true');

          var panel = qs('[data-tab-panel="' + target + '"]', tabsEl)
                   || panels[btns.indexOf(btn)];
          if (panel) panel.classList.add('lv-tabs__panel--active');
        });
      });
    });
  }

  /* ── 3. STICKY BAR ──────────────────────────────────────── */
  function initStickyBar() {
    var bar     = qs('#lv-sticky-bar');
    var mainCTA = qs('[name="add"]');
    var stickyBtn = qs('#lv-sticky-btn');
    if (!bar || !mainCTA) return;

    /* Mostrar/ocultar según visibilidad del botón principal */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('lv-sticky-bar--visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('lv-sticky-bar--visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(mainCTA);

    /* Botón sticky dispara submit del formulario nativo */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = mainCTA.closest('form');
        if (form) {
          mainCTA.click();
        }
      });
    }
  }

  /* ── 4. WHATSAPP — mensaje dinámico con producto ────────── */
  function initWhatsApp() {
    var waBtn = qs('.lv-whatsapp-btn');
    if (!waBtn) return;

    /* El href ya viene generado desde Liquid con el nombre del producto.
       Aquí solo añadimos el pack seleccionado si corresponde. */
    waBtn.addEventListener('click', function (e) {
      var activeOpt = qs('.lv-qty-opt--active');
      if (!activeOpt) return;
      var qty = activeOpt.dataset.qty;
      if (qty && qty !== '1') {
        e.preventDefault();
        var base = waBtn.href.split('text=')[0] + 'text=';
        var msg  = waBtn.href.split('text=')[1];
        var newMsg = decodeURIComponent(msg) + ' (pack x' + qty + ')';
        window.open(base + encodeURIComponent(newMsg), '_blank');
      }
    });
  }

  /* ── Init ───────────────────────────────────────────────── */
  function init() {
    initQtySelector();
    initTabs();
    initStickyBar();
    initWhatsApp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
